import { useContext } from "react"
import { Button } from "@headlessui/react"
import { TrashIcon } from "@heroicons/react/24/outline"
import { Panel } from "~/components/CommandMenu/Panel"
import { MultiContext } from "~/contexts/MultiContext"

export function Remove() {
  const { removeAll, removeVideo } = useContext(MultiContext)
  const onClick = ({ position, uuid }) => removeVideo(position, uuid)

  return (
    <Panel>
      <Panel.Buttons>
        <Button
          onClick={removeAll}
          className="flex h-fit items-center gap-2 rounded-lg bg-gray-900/10 px-4 py-2 text-sm text-gray-800 transition hover:bg-gray-600/10 focus:outline-none"
        >
          <TrashIcon aria-hidden="true" className="-ml-0.5 size-5" />
          Remove all
        </Button>
      </Panel.Buttons>
      <Panel.Layout Icon={TrashIcon} onClick={onClick} />
    </Panel>
  )
}
